import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { MovieCard } from "@/components/MovieCard";
import { useLang } from "@/context/LanguageContext";

export default function MyListPage() {
  const { t } = useLang();
  const [movies, setMovies] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/mylist");
    setMovies(data);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      <div className="pt-28 px-6 md:px-16 pb-16" data-testid="mylist-page">
        <h1 className="font-heading text-3xl md:text-4xl font-light tracking-tighter mb-8">{t("myList")}</h1>
        {!movies ? (
          <div className="w-8 h-8 border-2 border-[#E11D48] border-t-transparent rounded-full animate-spin" />
        ) : movies.length === 0 ? (
          <p className="text-zinc-400">{t("listEmpty")}</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-6">
            {movies.map((m) => <MovieCard key={m.id} movie={m} className="w-full" />)}
          </div>
        )}
      </div>
    </div>
  );
}
